/*
  Row-only size-pill alignment for the mobile collection grid.

  What it does: on mobile (2 products per row), measures each product's
  size-pill box (.m-pcard-size-panel) and sets the two boxes in the SAME row
  to match whichever one is taller. It does not touch any other row, and it
  does not touch the card as a whole — just this one box, which is what was
  actually causing the title/price below it to start at different heights.

  Why not pure CSS: this needs to compare two specific sibling elements'
  actual rendered content height against each other, in pairs, which is
  exactly what JS measurement is for — CSS alone can't target "just these two
  items in this row" without a layout restructure.
*/
(function () {
  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getRowPanels() {
    var container = document.querySelector('.m-collection-products');
    if (!container) return [];

    var items = Array.prototype.slice.call(container.children).filter(function (el) {
      return el.classList.contains('m-product-item');
    });

    return items.map(function (item) {
      return item.querySelector('.m-pcard-size-panel');
    });
  }

  function equalizeRows() {
    var panels = getRowPanels();
    if (!panels.length) return;

    if (!isMobile()) {
      panels.forEach(function (panel) {
        if (panel) panel.style.height = '';
      });
      return;
    }

    for (var i = 0; i < panels.length; i += 2) {
      var pair = [panels[i], panels[i + 1]].filter(Boolean);
      if (pair.length < 2) continue;

      // Reset to natural height first so we measure real content, not a
      // previously-applied equalized height from an earlier pass.
      pair.forEach(function (panel) {
        panel.style.height = '';
      });

      var tallest = 0;
      pair.forEach(function (panel) {
        tallest = Math.max(tallest, panel.getBoundingClientRect().height);
      });

      pair.forEach(function (panel) {
        panel.style.height = tallest + 'px';
      });
    }
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  var debouncedEqualize = debounce(equalizeRows, 150);

  document.addEventListener('DOMContentLoaded', equalizeRows);
  window.addEventListener('resize', debouncedEqualize);

  // If MinimogEvents is available (theme's pub/sub for grid updates, e.g.
  // after a load-more/infinite fetch), re-run whenever the product list
  // changes so newly-added rows get equalized too.
  if (window.MinimogEvents && typeof window.MinimogEvents.subscribe === 'function') {
    window.MinimogEvents.subscribe('ON_PRODUCT_LIST_UPDATED', equalizeRows);
  }
})();